module.exports = __webpack_public_path__ + "img/options-2-outline.png";